/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignTop: {
  name: 'align-top';
  data: string;
} = {
  name: 'align-top',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 21a1 1 0 1 1-2 0V9.414l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 9.414V21ZM4 2a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
